"use client";
import { create } from "zustand";

// Define the store type
interface SeoURLStore {
  seoLinks: any;
  setSeoLinks: (links: any) => void;
}

// Create the Zustand store
export const useSeoURLStore = create<SeoURLStore>((set) => ({
  seoLinks: null,
  setSeoLinks: (links) => set({ seoLinks: links }),
}));
